import React from "react";
// import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";

// core components
import GridContainer from "components/GridContainer";
import GridItem from "components/GridItem";
// import NavPills from "components/NavPills";
import Card from "components/Card";
import CardBody from "components/CardBody";
import Button from "components/Button";
import colors from "utils/colors";

import {
  container,
  mrAuto,
  mlAuto,
  title,
  cardTitle,
  whiteColor,
  infoColor,
  hexToRgb,
} from "assets/jss/material-kit-pro-react.jsx";

const PriceCard = ({ classes, price, title, userCount, onContactClick }) => {
  return (
    <Card raised pricing className={classes.cardPricing}>
      <CardBody style={{ padding: "12px 0" }}>
        <h4 className={classes.pricingTitle}>{title}</h4>
        <div>
          <div>
            {userCount < 50 && (
              <h1>
                <small style={{ color: colors.purple.main }}>$</small>
                <span style={{ color: colors.purple.main }}>{price}</span>
                <small style={{ fontWeight: "lighter" }}>/month</small>
              </h1>
            )}
            {userCount >= 50 && (
              <h3
                style={{
                  paddingTop: "18px",
                  paddingBottom: "42px",
                  color: colors.purple.main,
                  fontWeight: "normal",
                  fontSize: 28,
                }}>
                Custom Pricing
              </h3>
            )}
            {userCount < 50 && <div style={{ fontSize: "1em", color: "rgba(0, 0, 0, 0.5)" }}>(billed annualy)</div>}
          </div>
        </div>
        <div style={{ margin: "0.75em 0" }}>
          {userCount < 50 ? `up to ${userCount} users` : `above ${userCount} users`}
        </div>
        <Divider />

        <ul>
          <li>Free onboarding</li>
          <li>Custom Timelines</li>
          <li>Unlimited activities</li>
          <li>Free online Support</li>
        </ul>
        <Button href="#pablo" color="purple" round onClick={e => onContactClick(e, title)}>
          Contact Us
        </Button>
      </CardBody>
    </Card>
  );
};

const useStyles = makeStyles(theme => ({
  mrAuto,
  mlAuto,
  container: {
    ...container,
    backgroundColor: "#F7F9FA",
  },
  title: {
    ...title,
    marginTop: 0,
    marginBottom: 0,
    textAlign: "center",
  },
  cardTitle,
  cardTitleWhite: {
    "&, & a": {
      marginTop: "0",
      marginBottom: "0",
      minHeight: "0",
    },
    color: whiteColor + " !important",
    "& small": {
      color: "rgba(" + hexToRgb(whiteColor) + ",0.8)!important",
    },
  },
  textCenter: {
    textAlign: "center",
  },
  pricingSection: {
    padding: "50px 0px",
  },
  textInfo: {
    color: infoColor[0] + " !important",
  },
  pricingContainer: {
    padding: "0 40px",
  },
  pricingTitle: {
    fontWeight: "normal",
    fontSize: 20,
  },
  cardPricing: {
    "& ul li": {
      padding: "6px 0px",
      border: 0,
      color: "#333333",
    },
  },
  everything: {
    fontWeight: 500,
    padding: "1em 2.5em 0.75em 2.5em",
    [theme.breakpoints.down("md")]: {
      padding: "1em 2em 0.75em 2em",
    },
  },
  offer: {
    color: "#7446C4",
    textAlign: "center",
  },
  offer2: {
    marginTop: "1.5em",
    color: "#7446C4",
    textAlign: "center",
  },
}));

const Pricing = props => {
  const classes = useStyles();

  // const [active, setActive] = React.useState(1);

  // const handleChange = (_, active) => {
  //   setActive(active);
  // };

  const onContactClick = (e, plan) => {
    e.preventDefault();
    props.history.push("/demo", { products: "OptaPlan", plan });
  };

  return (
    <div className={classes.container}>
      <div className={classes.pricingSection}>
        <div>
          <h2 className={classes.title}>Pricing</h2>
        </div>
        {/* <GridContainer>
          <GridItem md={6} sm={6} className={classNames(classes.mrAuto, classes.mlAuto, classes.textCenter)}>
            <NavPills
              alignCenter
              color="purple"
              active={active}
              onChange={handleChange}
              tabs={[{ tabButton: "Monthly" }, { tabButton: "Yearly" }]}
            />
          </GridItem>
        </GridContainer> */}
        {/* <div className={classes.offer}>
          <p>Save 25% by paying yearly!</p>
        </div> */}
        <div className={classes.offer2}>
          <p style={{ fontSize: 20 }}>7 day free trial. No credit card required.</p>
        </div>
        <GridContainer justify="center" alignItems="stretch" className={classes.pricingContainer}>
          <GridItem xs={12} sm={6} md={3}>
            <PriceCard
              classes={classes}
              title="Business Starter"
              price={110}
              userCount={5}
              onContactClick={onContactClick}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <PriceCard
              classes={classes}
              title="Business Standard"
              price={160}
              userCount={10}
              onContactClick={onContactClick}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <PriceCard
              classes={classes}
              title="Business Plus"
              price={340}
              userCount={25}
              onContactClick={onContactClick}
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <PriceCard classes={classes} title="Enterprise" userCount={50} onContactClick={onContactClick} />
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
};

export default Pricing;
